module.exports = __webpack_public_path__ + "img/1f_r_twodays.e84eefb3.jpg";